/** VendorsPageRoute — skin-aware switcher for /vendors. */
import { useUISkin } from "@/data/UISkinContext";
import VendorsPage from "./VendorsPage";
import VendorsPageCockpit from "./VendorsPageCockpit";

export default function VendorsPageRoute() {
  const { skin } = useUISkin();
  if (skin === "cockpit") return <VendorsPageCockpit />;
  return <VendorsPage />;
}
